export const formatDuration = (seconds: number, desiredFormat = '') => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  if (desiredFormat === 'MM:SS') {
    let formattedMinutes;
    let formattedSeconds;
    if (minutes < 10) {
      formattedMinutes = `0${minutes}`;
    } else {
      formattedMinutes = minutes;
    }

    if (remainingSeconds < 10) {
      formattedSeconds = `0${remainingSeconds}`;
    } else {
      formattedSeconds = remainingSeconds;
    }
    return `${formattedMinutes}:${formattedSeconds}`;
  } else {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    if (minutes === 0) {
      return `${remainingSeconds} sec`;
    } else if (remainingSeconds === 0) {
      return `${minutes} min`;
    } else {
      return `${minutes} min ${remainingSeconds} sec`;
    }
  }
};
